module.exports = __webpack_public_path__ + "img/quick_05.05e4df4b.png";